export default {
  isShown: (state) => state.isShown,
  transactionsId: (state) => state.transactionsId,
  typeModal: (state) => state.typeModal,
  errors: (state) => state.errors,
};
